export const MUTATE = 'MUTATE';
export const MUTATE_OBJECT_KEY = 'MUTATE_OBJECT_KEY';
export const MUTATE_MULTIPLE = 'MUTATE_MULTIPLE';
export const MUTATE_ARRAY_INDEX = 'MUTATE_ARRAY_INDEX';
export const MUTATE_OBJECT_KEY_IN_ARRAY = 'MUTATE_OBJECT_KEY_IN_ARRAY';
